import React from "react";
import ReactDOM from "react-dom/client";
import store from "./gStore/Store";
import { AuthProvider } from "./Context/AuthProvider";
import jMoment from "moment-jalaali";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import "./App.css";
import App from "./App";
import { Provider } from "react-redux";
import fnFetchSidebarFronJson from "./utils/fnFetchSidebarFronJson";
const root = ReactDOM.createRoot(document.getElementById("root"));

jMoment.loadPersian({ dialect: "persian-modern", usePersianDigits: true });

root.render(
  <>
    <AuthProvider>
      <BrowserRouter>
        <Provider store={store}>
          <App />
        </Provider>
      </BrowserRouter>
    </AuthProvider>
  </>
);
